import { createAsyncTypes } from 'store/utils';
import { Country } from 'components/PhoneNumberInput';

// State Key
export const KEY = 'customer';

// Action Types
export const types = {
  GET_CUSTOMER_ASYNC: createAsyncTypes(`${KEY}/GET_CUSTOMER_ASYNC`),
  SAVE_CUSTOMER_ASYNC: createAsyncTypes(`${KEY}/SAVE_CUSTOMER_ASYNC`),
  SAVE_SURVEY_ASYNC: createAsyncTypes(`${KEY}/SAVE_SURVEY_ASYNC`),
  GET_LOCATIONS_ASYNC: createAsyncTypes(`${KEY}/GET_LOCATIONS_ASYNC`),
  SET_LOOKUP_DATA: `${KEY}/SET_LOOKUP_DATA`,
  RESET_CUSTOMER: `${KEY}/RESET_CUSTOMER`,
  RESET_ERROR: `${KEY}/RESET_ERROR`,
  RESET_LOCATIONS: `${KEY}/RESET_LOCATIONS`,
  SET_PHONE_COUNTRY: `${KEY}/SET_PHONE_COUNTRY`,
  SET_IS_LOCAL: `${KEY}/SET_IS_LOCAL`
};

export interface Customer {
  readonly customerId?: string;
  readonly email?: string;
  readonly firstName?: string;
  readonly lastName?: string;
  readonly phone?: string;
  readonly postalCode?: string;
  readonly street1?: string;
  readonly street2?: string;
  readonly city?: string;
  readonly state?: string;
  readonly country?: string;
}

export interface CustomerState {
  readonly customer: Customer | null;
  readonly lookupData: any;
  readonly survey: any;
  readonly phoneCountry: Country | undefined;
  readonly loading: boolean;
  readonly error: undefined | string;
  readonly locations: Location[] | null;
  readonly isLocal: boolean;
}

// Save Customer
export interface SaveCustomerPayload {
  email?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  postalCode?: string;
  street1?: string;
  street2?: string;
  city?: string;
  state?: string;
  country?: string;
}

export interface GetCustomerPayload {
  email?: string;
  firstName?: string;
  lastName?: string;
  postalCode?: string;
  phone?: string;
  username?: string;
  narrowResultsToOne?: boolean;
}

export interface GetLocationsPayload {
  postalCode?: string;
}

export interface Location {
  city: string;
  county: string;
  state: string;
  country: string;
}

export interface SaveCustomerAsyncRequest {
  type: typeof types.SAVE_CUSTOMER_ASYNC.REQUEST;
  payload: SaveCustomerPayload;
}

export interface SaveCustomerAsyncError {
  type: typeof types.SAVE_CUSTOMER_ASYNC.ERROR;
  payload: string;
}

export interface SaveCustomerAsyncPending {
  type: typeof types.SAVE_CUSTOMER_ASYNC.PENDING;
  payload: boolean;
}

export interface SaveCustomerAsyncSuccess {
  type: typeof types.SAVE_CUSTOMER_ASYNC.SUCCESS;
  payload: Customer;
}

export interface GetCustomerAsyncRequest {
  type: typeof types.GET_CUSTOMER_ASYNC.REQUEST;
  payload: GetCustomerPayload;
}

export interface GetCustomerAsyncError {
  type: typeof types.GET_CUSTOMER_ASYNC.ERROR;
  payload: {
    message: string;
    code: number;
  };
}

export interface GetCustomerAsyncPending {
  type: typeof types.GET_CUSTOMER_ASYNC.PENDING;
  payload: boolean;
}

export interface GetCustomerAsyncSuccess {
  type: typeof types.GET_CUSTOMER_ASYNC.SUCCESS;
  payload: Customer;
}

export interface SaveSurveyAsyncRequest {
  type: typeof types.SAVE_SURVEY_ASYNC.REQUEST;
  payload: { details: any };
}

export interface SaveSurveyAsyncError {
  type: typeof types.SAVE_SURVEY_ASYNC.ERROR;
  payload: string;
}

export interface SaveSurveyAsyncPending {
  type: typeof types.SAVE_SURVEY_ASYNC.PENDING;
  payload: boolean;
}

export interface SaveSurveyAsyncSuccess {
  type: typeof types.SAVE_SURVEY_ASYNC.SUCCESS;
  payload: any;
}

export interface ResetCustomer {
  type: typeof types.RESET_CUSTOMER;
}

export interface ResetError {
  type: typeof types.RESET_ERROR;
}

export interface ResetLocations {
  type: typeof types.RESET_LOCATIONS;
}

export interface SetLookupData {
  type: typeof types.SET_LOOKUP_DATA;
  payload: any;
}

export interface SetPhoneCountry {
  type: typeof types.SET_PHONE_COUNTRY;
  payload: Country | undefined;
}

export interface GetLocationsAsyncRequest {
  type: typeof types.GET_LOCATIONS_ASYNC.REQUEST;
  payload: { postalCode: string };
}

export interface GetLocationsAsyncSuccess {
  type: typeof types.GET_LOCATIONS_ASYNC.SUCCESS;
  payload: Location[];
}

export interface GetLocationsAsyncPending {
  type: typeof types.GET_LOCATIONS_ASYNC.PENDING;
  payload: boolean;
}

export interface GetLocationsAsyncError {
  type: typeof types.GET_LOCATIONS_ASYNC.ERROR;
  payload: string;
}

export interface SetIsLocal {
  type: typeof types.SET_IS_LOCAL;
  payload: boolean;
}

export type CustomerActionTypes =
  | GetCustomerAsyncRequest
  | GetCustomerAsyncSuccess
  | GetCustomerAsyncPending
  | GetCustomerAsyncError
  | SaveCustomerAsyncRequest
  | SaveCustomerAsyncPending
  | SaveCustomerAsyncError
  | SaveCustomerAsyncSuccess
  | SaveSurveyAsyncRequest
  | SaveSurveyAsyncPending
  | SaveSurveyAsyncError
  | SaveSurveyAsyncSuccess
  | ResetCustomer
  | ResetError
  | ResetLocations
  | SetLookupData
  | SetPhoneCountry
  | GetLocationsAsyncRequest
  | GetLocationsAsyncSuccess
  | GetLocationsAsyncPending
  | GetLocationsAsyncError
  | SetIsLocal;
